module.exports = __webpack_public_path__ + "static/wechat-logo-7e1d8e4a1b1407006735fe6c3b375bf1.png";